import "./SubsidiaryCard.css";

function SubsidiaryCard({ subsidiary }) {
  return (
    <div className="subsidiary-card">
      <div className="subsidiary-info">
        <span className="subsidiary-name">{subsidiary.name}</span>
      </div>
      <div className="subsidiary-count">
        <span className="count-badge">{subsidiary.userCount} users</span>
      </div>
    </div>
  );
}

export default SubsidiaryCard;
